import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import InvoiceRequest from '@models/requests/invoice-request.model';
import { EnvironmentService } from '@services/environment-service/environment.service';



@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private static readonly CONTROLLER_ROOT = 'v1/invoice';

  constructor(private httpClient: HttpClient) { }

  createInvoice(data?: InvoiceRequest) {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${InvoiceService.CONTROLLER_ROOT}`;
    
    const response = this.httpClient.request('POST', endpoint, { body: data, observe: 'response', responseType: 'blob' });

    return response;
  }
}


